import type { Language } from "../../i18n/locale";

/**
 * QR 에 실을 공유 페이지 주소 — 세션 `downloadUrl` 에 손님 언어를 `?lang=` 으로 붙인다
 * (BOOTH-32, `/p/:code` 가 ko/en/ja/zh 지원). 사진 받기·인쇄·thanks 세 화면이 같은 주소를 쓴다 (BOOTH-63).
 */
export function shareQrUrl(downloadUrl: string | null, language: Language): string | null {
  if (!downloadUrl) return null;
  return `${downloadUrl}?lang=${language}`;
}
